import { deepMerge } from '@antfu/utils'
import { createVuetify } from 'vuetify'
import { VBtn } from 'vuetify/components/VBtn'
import { VDateInput } from 'vuetify/labs/VDateInput'
import defaults from './defaults'
import { icons } from './icons'
import {
  themes,
  lightThemePrimaryColor,
  lightThemePrimaryDarkenColor,
  darkThemePrimaryColor,
  darkThemePrimaryDarkenColor,
} from './theme'
import { themeConfig } from '@themeConfig'

// Styles
import { cookieRef } from '@/@layouts/stores/config'
import '@core/scss/template/libs/vuetify/index.scss'
import 'vuetify/styles'

export default function (app) {
  const cookieThemeValues = {
    defaultTheme: resolveVuetifyTheme(themeConfig.app.theme),
    themes: {
      light: {
        colors: {
          'primary': cookieRef('lightThemePrimaryColor', lightThemePrimaryColor).value,
          'primary-darken-1': cookieRef('lightThemePrimaryDarkenColor', lightThemePrimaryDarkenColor).value,
        },
      },
      dark: {
        colors: {
          'primary': cookieRef('darkThemePrimaryColor', darkThemePrimaryColor).value,
          'primary-darken-1': cookieRef('darkThemePrimaryDarkenColor', darkThemePrimaryDarkenColor).value,
        },
      },
    },
  }

  const optionTheme = deepMerge({ themes }, cookieThemeValues)

  const vuetify = createVuetify({
    aliases: {
      IconBtn: VBtn,
    },
    defaults,
    icons,
    theme: optionTheme,
    components: {
      VDateInput,
    },
  })

  app.use(vuetify)
}
